// @flow
import {
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  TEMPORARY_EVENT_CANCELLED,
  TEMPORARY_EVENT_COMPLETED,
  TEMPORARY_EVENT_ADDED,
} from '../types/temporaryEvents';
import * as selectors from '../reducers';
import * as fromTemporaryEvents from '../reducers/temporaryEvents';
import * as actions from '../actions/temporalBanners';

const GROUP = 'temporalBanners';

function* nextTemporalBanner(action) {
  const { id } = action.payload;
  const temporalBanner = yield select(selectors.getTemporaryEvent, id);

  if (temporalBanner.group !== GROUP) {
    return;
  }

  const temporaryEvents = yield select(selectors.getTemporaryEventsByGroup, GROUP);
  const readyTemporaryEvents = temporaryEvents.filter(
    event => !(event.isCompleted || event.isCanceled) && !event.active,
  ); 

  if (readyTemporaryEvents.length < 1) {
    return;
  }

  const next = readyTemporaryEvents.slice(-1)[0];

  yield put(actions.activate(next.id));
}

function* newTemporalBanner(action) {
  const { id } = action.payload;
  const temporalBanner = yield select(selectors.getTemporaryEvent, id);

  if (temporalBanner.group !== GROUP) {
    return;
  }

  const temporaryEvents = yield select(selectors.getTemporaryEventsByGroup, GROUP);
  const activeEvents = temporaryEvents.filter(
    event => fromTemporaryEvents.isActive(event),
  );
  if (activeEvents.length >= 1) {
    return;
  }

  const readyTemporaryEvents = temporaryEvents.filter(
    event => !(event.isCompleted || event.isCanceled) && !event.active,
  );
  if (readyTemporaryEvents <= 1) {
    return;
  }

  yield put(actions.activate(id));
}

export function* watchNextTemporalBanner(): Iterator<any> {
  yield takeEvery(
    TEMPORARY_EVENT_CANCELLED,
    nextTemporalBanner,
  );
  yield takeEvery(
    TEMPORARY_EVENT_COMPLETED,
    nextTemporalBanner,
  );
}

export function* watchNewTemporalBanner(): Iterator<any> {
  yield takeEvery(
    TEMPORARY_EVENT_ADDED,
    newTemporalBanner,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/temporalBanners.js